import { stateType } from "../../state";
import {
	BOX_SHADOWS,
	DATA_TYPES,
	EMPTY_MESSAGES,
	EMPTY_MESSAGE_IMAGES,
	FONTS,
	PRIMARY_COLOR,
	SECONDARY_COLOR,
} from "../../constants";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { BoxHeader } from "../Common/BoxHeader";
import { Chart } from "react-google-charts";
import { BAR_COLORS } from "../VariableCorrelations/DualChart";
import { ChartXTitle, ChartYTitle } from "../CohortAnalysis/Charts/ColumnChart";
import { EmptyMessage } from "../Common/EmptyMessage";
import { useState } from "react";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			display: "flex",
			flexDirection: "column",
			width: "100%",
			backgroundColor: "white",
			boxShadow: BOX_SHADOWS,
			borderRadius: "10px",
			height: "520px",
		},
		chartContainer: {
			width: "90%",
			height: "60%",
			marginLeft: "5%",
		},
		chartContainer2: {
			width: "100%",
			height: "100%",
			display: "flex",
			flexDirection: "column",
			position: "relative",
		},
	})
);

function VarImportanceChart({ state }: stateType) {
	const classes = useStyles();
	const [tmp, settmp] = useState(true);

	const varImSize = Object.keys(
		state.saveState.variableImportance.varImportance
	).length;
	if (varImSize === 0) {
		return (
			<div style={{ marginTop: "-80px" }}>
				<EmptyMessage
					button={false}
					image={EMPTY_MESSAGE_IMAGES.noData}
					message1={EMPTY_MESSAGES.noVarImportance1}
					message2={EMPTY_MESSAGES.noVarImportance2.replace(
						"{r1}",
						state.saveState.modelTraining.valueToPredict
					)}
				></EmptyMessage>
			</div>
		);
	}

	let data: any[] = [["", "", { role: "style" }]];

	let cols = state.saveState.dataset.columns.filter(
		(v) =>
			v.columnType !== DATA_TYPES.unusable &&
			v.columnName !== state.saveState.modelTraining.valueToPredict
	);
	// if (tmp) {
	// 	console.log(state.saveState.variableImportance);
	// 	delete state.saveState.variableImportance.varImportance["Monthly Premiums"];
	// 	delete state.saveState.variableImportance.varImpact["Monthly Premiums"];
	// 	settmp(false)
	// 	state.setSaveState(state.saveState);
	// }

	for (let col of cols) {
		if (
			col.columnName in state.saveState.variableImportance.varImportance
		) {
			data.push([
				col.columnName,
				state.saveState.variableImportance.varImportance[
					col.columnName
				],
				`fill-color: ${SECONDARY_COLOR}; fill-opacity: ${0.7}; stroke-color: #76A7FA; stroke-width: 0;`,
			]);
		}
	}

	return (
		<div className={classes.chartContainer}>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					marginTop: "10px",
				}}
			>
				<ChartYTitle yName={"Importance Score"}></ChartYTitle>
				<div className={classes.chartContainer2}>
					<ChartXTitle xName={"Column Name"}></ChartXTitle>
					<div
						style={{
							height: "100%",
							width: "100%",
							marginLeft: "0%",
						}}
					>
						<Chart
							style={{
								height: "400px",
								width: "100%",
								zIndex: 1000,
							}}
							chartType={"ColumnChart"}
							loader={<div>Loading Chart</div>}
							data={data}
							options={{
								// Material design options
								colors: [PRIMARY_COLOR, PRIMARY_COLOR],
								legend: { position: "none" },
								chartArea: {
									width: "100%",
									height: "100%",
									top: 10,
									bottom: 60,
									left: 40,
								},

								vAxis: {
									minorGridlines: { color: "white" },
									gridlines: { color: "rgb(220,220,220)" },
									baselineColor: "rgb(220,220,220)",
								},
								hAxis: {
									minorGridlines: { color: "white" },
									baselineColor: "rgb(220,220,220)",
									gridlines: { color: "rgb(220,220,220)" },
								},

								annotations: {
									alwaysOutside: true,
									textStyle: {
										color: PRIMARY_COLOR,
										fontSize: 14,
										fontFamily: FONTS,
									},
								},
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export function VariableImportanceBox({ state }: stateType) {
	const classes = useStyles();
	return (
		<div className={classes.container}>
			{" "}
			<BoxHeader
				title={`Variable Importance for: ${state.saveState.modelTraining.valueToPredict}`}
				toolTip={`Shows which variables have the largest relative influence on predicting '${state.saveState.modelTraining.valueToPredict}'. A value of 100 means this variable alone can be used to predict '${state.saveState.modelTraining.valueToPredict}' with 100% accuracy.`}
				line={false}
			></BoxHeader>
			<VarImportanceChart state={state}></VarImportanceChart>
		</div>
	);
}
